module.exports = __webpack_public_path__ + "static/media/kyc_business_details.e17e4ea2.svg";